import React from 'react'
import "./PageHeader.css"
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';

function PageHeader({title}) {
    const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className='page_header_container'>
      <Container>
        <div className='breadcrumb'>
          <Link to="/">
            {currentLocal.home.home}
          </Link>
          / {title}
        </div>
        <h1 >
          {title}
        </h1>
      </Container>
    </div>  )
}

export default PageHeader